import { render, staticRenderFns } from "./DeleteObject.vue?vue&type=template&id=26ef1b4f&scoped=true&"
import script from "./DeleteObject.vue?vue&type=script&lang=js&"
export * from "./DeleteObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ef1b4f",
  null
  
)

export default component.exports